import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './LandingNavbar.css';

const LandingNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  const scrollToFeatures = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const el = document.getElementById('features');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        setMenuOpen(false);
      }
    }
  };

  return (
    <nav className={`ln-navbar${scrolled ? ' ln-navbar--scrolled' : ''}`}>
      <div className="ln-navbar-inner">
        <Link to="/" className="ln-navbar-logo">
          <img src="/favicon.png" alt="Hisab OK Hai" />
          <span>Hisab OK Hai</span>
        </Link>

        <div className={`ln-navbar-links${menuOpen ? ' ln-navbar-links--open' : ''}`}>
          <Link to="/" className={`ln-nav-link${isActive('/') ? ' ln-nav-link--active' : ''}`}>Home</Link>
          <a href="/#features" onClick={scrollToFeatures} className="ln-nav-link">Features</a>
          <Link to="/expense-tracker-india" className={`ln-nav-link${isActive('/expense-tracker-india') ? ' ln-nav-link--active' : ''}`}>Pricing</Link>
          <Link to="/login" className="ln-nav-btn ln-nav-btn--outline">Login</Link>
          <Link to="/signup" className="ln-nav-btn ln-nav-btn--primary">Free Start Karein</Link>
        </div>

        <button
          className={`ln-hamburger${menuOpen ? ' ln-hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {menuOpen && <div className="ln-navbar-overlay" onClick={() => setMenuOpen(false)} />}
    </nav>
  );
};

export default LandingNavbar;
